import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { MiVerificationSubsidy } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-mi-verification-subsidy-report',
  templateUrl: './mi-verification-subsidy-report.component.html',
  styleUrls: ['./mi-verification-subsidy-report.component.scss']
})
export class MiVerificationSubsidyReportComponent implements OnInit {

  miVerfSubsidy: any[];
  totalArea:number;
  estAmount:number;
  boqAmount:number;
  pvaAmount:number;
  grandTotalArea:number;
  grandEstAmount:number;
  grandBoqAmount:number;
  grandPvaAmount:number;
  arrayIndex:number;
  tempMiVerfSubsidy: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: MiVerificationSubsidy[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
        
      this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_MI_Area_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_MI_Area_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getMiVerificationSubsidy_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.activityRecordService.activityRecord(this.userID, 'MI Verification Subsidy Report', '', new Date(), 'Success');
            // this.loader.close();
            this.loading = false;
            if (data?.length > 0) {
              this.miVerfSubsidy = data;
              this.appVerificationModel = data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.miVerfSubsidy = [];
              this.appVerificationModel = [];
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'MI Verification Subsidy Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          
          "District" : d.District,
          "Block" : d.Block,
          "Constituency": d.Constituency,
          "Village": d.Village,
          "Application No": d.Application_No,
          "Farmer Name": d.farmerName,
          "Father  Name": d.Father_name,
          "Programme Name": d.ProgrammeName,
          "Total Area": d.TotalArea,
          "Estimate Amount": d.EstimateAmount,
          "BOQ Amount": d.BOQAmount,
          "PV Amount": d.PVAmount,
          "verification date": d.verification_date,
          "Mobile": d.Mobile,
          "Vendor Name": d.VendorName,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      {field: 'Block', header: 'Block'},
      { field: 'Constituency', header: 'Constituency' },
      { field: 'Village', header: 'Village' },
      {field: 'Application_No', header: 'Application No'},
      {field: 'farmerName', header: 'Farmer Name'},
      {field: 'Father_name', header: 'Father Name'},
      {field: 'ProgrammeName', header: 'Programme Name'},
      {field: 'TotalArea', header: 'Total Area'},
      {field: 'EstimateAmount', header: 'Estimate Amount'},
      {field: 'BOQAmount', header: 'BOQ Amount'},
      {field: 'PVAmount', header: 'PV Amount'},
      {field: 'verification_date', header: 'verification date'},
      {field: 'Mobile', header: 'Mobile'},
      {field: 'VendorName', header: 'Vendor Name'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempMiVerfSubsidy=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
    onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
       // console.log(event);
      }
      calculateTotalApp() {
        this.totalArea=0;
        this.estAmount=0;
        this.boqAmount=0;
        this.pvaAmount=0;      
        for(let i=this.arrayIndex ;this.tempMiVerfSubsidy.length>10?i<this.arrayIndex+10:i<this.tempMiVerfSubsidy.length;i++) {
          this.totalArea +=this.tempMiVerfSubsidy[i].TotalArea;
          this.estAmount +=this.tempMiVerfSubsidy[i].EstimateAmount;
          this.boqAmount += this.tempMiVerfSubsidy[i].BOQAmount;
          this.pvaAmount +=this.tempMiVerfSubsidy[i].PVAmount;
        }     
    }

    calculateGrandTotal(){
      this.grandTotalArea=0;
      this.grandEstAmount=0;
      this.grandBoqAmount=0;
      this.grandPvaAmount=0;
      for(let miVerfData of this.miVerfSubsidy) {
        this.grandTotalArea += miVerfData.TotalArea;
        this.grandEstAmount += miVerfData.EstimateAmount;
        this.grandBoqAmount += miVerfData.BOQAmount;
        this.grandPvaAmount += miVerfData.PVAmount;
    }
    }

}
